import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";

interface CopyrightConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export default function CopyrightConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
}: CopyrightConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[min(430px,calc(100vw-2rem))] border-white/10 bg-black p-8 text-white shadow-[0_26px_70px_rgba(0,0,0,0.72)] sm:max-w-none">
        <DialogTitle className="sr-only">Confirm original content</DialogTitle>
        <DialogDescription className="pr-8 text-sm leading-relaxed text-white/90">
          Using content you don't own may violate copyright laws. By continuing,
          you confirm this is your own original content.
        </DialogDescription>
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onConfirm}
            className="min-w-32 rounded-full bg-[#4f46e5] px-6 py-3 text-base font-medium text-white shadow-[0_10px_28px_rgba(79,70,229,0.38)] transition-colors hover:bg-[#5b52f0]"
          >
            Confirm
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
